module.exports = __webpack_public_path__ + "img/arrow-value-dec.4358feaf.svg";